var _ = require('underscore');

var exp = {
  Team: {
    Admin: 'admin',
  },
  Event: {
    Admin: 'admin',
    ReadOnly: 'readOnly',
    ShowCaller: 'showCaller',
    Contributor: 'contributor',
  },
};

exp.Team.All = _.values(exp.Team);
exp.Event.All = _.values(exp.Event);

module.exports = exp;
